import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Arjaan_Burjuman_Hotel.webp';

const Project_nineteens = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Arjaan Burjuman Hotel</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A premium hotel managed under the Arjaan by Rotana brand within the Burjuman development in Bur Dubai. The retrofit
                scope involved upgrading core MEP systems while maintaining full operational continuity of the live hotel environment.</p>
              <p>MAIN CONTRACTOR : ALEC</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : Retrofit of CHW, ducting and electrical systems</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_nineteens